/* FSLA — "Enroll Now" -> contact popup wiring
   Makes every "Enroll Now" button/link open the existing #fslaContact
   popup instead of navigating to the product/checkout page. The popup
   lives in layout/theme.liquid and submits through Shopify's native
   contact form, so submission handling is unchanged. */
(function () {
  'use strict';

  var PROGRAM_BY_HANDLE = {
    'private-pilot-license': 'Private Pilot License',
    'comprehensive-private-pilot': 'Private Pilot License',
    'turbo-cirrus-private-pilot': 'Private Pilot License',
    'sport-pilot-license': 'Sport Pilot License',
    'instrument-rating': 'Instrument Rating',
    'multi-engine-rating': 'Multi-Engine Rating',
    'commercial-pilot-license': 'Commercial Pilot License',
    'flight-instructor-cfi': 'Flight Instructor (CFI)',
    'airline-pilot-program': 'Airline Pilot Program',
    'teen-flight-training': 'Teen Flight Training',
    'discovery-flight': 'Discovery Flight'
  };

  function currentProgram() {
    var seg = (location.pathname || '').split('/').filter(Boolean).pop() || '';
    return PROGRAM_BY_HANDLE[seg] || '';
  }

  function openPopup(popup) {
    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var prog = currentProgram();
    if (prog) {
      var sel = popup.querySelector('select[name="contact[Program of Interest]"]');
      if (sel && !sel.value) {
        for (var i = 0; i < sel.options.length; i++) {
          if ((sel.options[i].text || '').trim() === prog) { sel.selectedIndex = i; break; }
        }
      }
    }

    var first = popup.querySelector('input, select, textarea');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function isEnrollTrigger(el) {
    if (el.closest('#fslaContact')) return false;
    var txt = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return txt.indexOf('enroll now') !== -1;
  }

  function wire() {
    var popup = document.getElementById('fslaContact');
    if (!popup) return;

    var nodes = document.querySelectorAll('a, button');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-fsla-enroll')) continue;
      if (!isEnrollTrigger(el)) continue;
      el.setAttribute('data-fsla-enroll', '1');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openPopup(popup);
      });
    }
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);

  document.addEventListener('shopify:section:load', wire);
})();